export default __webpack_public_path__ + "media/images/casatb/about_us/flavio-mendonca-6e6bfcde042106e5d9ec1818d6096b7b.png";